(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veylmont-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('veylmont-dynamic-hero')) {
    customElements.define('veylmont-dynamic-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-slide-button]'));
        this.currentSlide = 0;
        this.interval = Number(this.dataset.interval) || 6000;
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pointerStart = null;

        this.querySelector('[data-previous-slide]')?.addEventListener('click', () => this.showSlide(this.currentSlide - 1, true));
        this.querySelector('[data-next-slide]')?.addEventListener('click', () => this.showSlide(this.currentSlide + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.showSlide(Number(dot.dataset.slideButton), true)));

        this.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse') this.pointerStart = event.clientX;
        });
        this.addEventListener('pointerup', (event) => {
          if (this.pointerStart === null) return;
          const distance = event.clientX - this.pointerStart;
          this.pointerStart = null;
          if (Math.abs(distance) > 45) this.showSlide(this.currentSlide + (distance < 0 ? 1 : -1), true);
        });
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.start());
        this.visibilityHandler = () => document.hidden ? this.pause() : this.start();
        document.addEventListener('visibilitychange', this.visibilityHandler);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
              this.classList.add('is-visible');
              this.start();
              this.observer.disconnect();
            }
          }, { threshold: 0.18 });
          this.observer.observe(this);
        } else {
          this.classList.add('is-visible');
          this.start();
        }
      }

      showSlide(index, userInitiated = false) {
        if (this.slides.length < 2) return;
        const target = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === target;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === target;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        this.currentSlide = target;
        if (userInitiated) {
          this.pause();
          this.start();
        }
      }

      start() {
        if (!this.autoplayEnabled || this.reducedMotion || this.slides.length < 2 || this.timer) return;
        this.timer = window.setInterval(() => this.showSlide(this.currentSlide + 1), this.interval);
      }

      pause() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }

      disconnectedCallback() {
        this.pause();
        if (this.observer) this.observer.disconnect();
        if (this.visibilityHandler) document.removeEventListener('visibilitychange', this.visibilityHandler);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veylmont-size-chart"] && !Shopify.designMode) return;
  try {
    
  if (!window.vmSizeGuideDialogBound) {
    window.vmSizeGuideDialogBound = true;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-vm-size-guide-open]');
      if (trigger) {
        const dialog = document.getElementById('vm-size-guide-dialog');
        if (dialog && !dialog.open) dialog.showModal();
      }
      const dialog = event.target.closest('#vm-size-guide-dialog');
      if (dialog && event.target === dialog) dialog.close();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
